import { render } from "./Depositi.vue?vue&type=template&id=4ffe79f6"
import script from "./Depositi.vue?vue&type=script&lang=js"
export * from "./Depositi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__